import { JobHistoryPage } from "../jobs/JobHistoryPage";

export function JobsRoute() {
    return <JobHistoryPage />;
}
